import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import Legend from "../../../Legend/Legend";
import { ckEditorToolbar } from "../../../../global/ckEditor";
// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { aisDetailFormStyle } from "../../../../styles/jss/components/AIS/aisDetailFormStyle";
const useStyles = makeStyles((theme) => aisDetailFormStyle(theme));
const AisEditActionItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const {
    setSelectEditDialogOpen,
    setActionItem,
    actionItem,
    setUpdateFlag,
    updateFlag,
    confirmDialogData,
    confirmDialogOpen,
  } = props;

  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  const handleInputChange = (name) => (event) => {
    setActionItem({ ...actionItem, [name]: event.target.value });
  };

  const handleDateFieldChange = (date, name) => {
    let data = { ...actionItem };
    data[name] = date;
    setActionItem({ ...actionItem, ...data });
  };

  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...actionItem };
    data[name] = inputData;

    setActionItem({ ...actionItem, ...data });
  };

  const statusCode = [
    { CODE: "PROG", NAME: "In Progress" },
    { CODE: "DEL", NAME: "Deleted" },
    { CODE: "NA", NAME: "N/A" },
    { CODE: "HOLD", NAME: "On Hold" },
    { CODE: "DUE", NAME: "Overdue" },
    { CODE: "PEND", NAME: "PENDING" },
  ];

  return (
    <Fragment>
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            fullWidth={true}
            id={"title"}
            name={"title"}
            label={"Action Header"}
            type="text"
            size="small"
            variant="outlined"
            value={actionItem.title || ""}
            onChange={handleInputChange("title")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            fullWidth={true}
            id={"status"}
            name={"status"}
            label={"Status"}
            select
            size="small"
            variant="outlined"
            value={actionItem.status || ""}
            onChange={handleInputChange("status")}
          >
            {statusCode.map((option) => (
              <MenuItem key={option.CODE} value={option.NAME}>
                {option.NAME}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.textField}
              id={"date"}
              inputVariant="outlined"
              fullWidth={true}
              name={"targetcompletiondate"}
              label={"Target Completion Date"}
              format="dd/MM/yyyy"
              placeholder="DD/MM/YYYY"
              size="small"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              className={classes.datePickerField}
              value={actionItem.targetcompletiondate || null}
              onChange={(date) =>
                handleDateFieldChange(date, "targetcompletiondate")
              }
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12}>
          <Legend id="desription" label="Action Detail (optional):">
            <CKEditor
              editor={ClassicEditor}
              data={actionItem.description}
              fullWidth={true}
              id={"description"}
              name={"description"}
              onChange={ckeditorHandleChange("description")}
              config={editorConfiguration}
            />
          </Legend>
        </Grid>
        <Grid item xs={12}>
          <Legend id="notes" label="Action Notes:">
            <CKEditor
              editor={ClassicEditor}
              data={actionItem.notes}
              fullWidth={true}
              id={"notes"}
              name={"notes"}
              onChange={ckeditorHandleChange("notes")}
              config={editorConfiguration}
            />
          </Legend>
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            fullWidth={true}
            id={"actionBy"}
            name={"actionBy"}
            label={"Action By(Optional)"}
            type="text"
            size="small"
            variant="outlined"
            value={actionItem.actionBy || ""}
            onChange={handleInputChange("actionBy")}
          ></TextField>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default AisEditActionItem;
